// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"dKlFGsBxNikOwnrbs7Lgv"};